import ClassRooms from './ClassRooms';

const ClassRoomShuffle = () => {
  return <ClassRooms withPagination={false} withFilter={false} limit={5} />;
};

export default ClassRoomShuffle;
